import AdminPortalContainer from "./AdminPortalContainer";
import AdminPortalStore from "./AdminPortalStore";

export default AdminPortalStore(AdminPortalContainer);
